import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '分区导航',
    links: [
      { label: '一区指南', href: '/category/zone-1' },
      { label: '二区指南', href: '/category/zone-2' },
      { label: '三区指南', href: '/category/zone-3' },
      { label: '分区对比', href: '/article/zone-comparison-guide' },
    ],
  },
  {
    title: '热门文章',
    links: [
      { label: '完整入门指南', href: '/article/zone-guide-complete-intro' },
      { label: '进阶攻略', href: '/article/zone-2-advanced-strategy' },
      { label: '深度洞察', href: '/article/zone-3-expert-insight' },
      { label: '划分标准详解', href: '/article/zone-standard-detail' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', href: '/about' },
      { label: '联系方式', href: '/about#contact' },
      { label: '用户口碑', href: '/about#reputation' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-800 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-guide-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-background-50 whitespace-nowrap">
                分区导航指南
              </span>
            </Link>
            <p className="text-sm text-background-300 leading-relaxed">
              最全面的一区二区三区导航指南，帮助您快速了解分区标准、核心差异及使用场景，精准定位所需内容。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                {group.title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-sm text-background-300 hover:text-background-100 transition-colors duration-200 whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-700 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} 分区导航指南. 版权所有.
          </p>
          <div className="flex items-center gap-4 text-xs text-background-400">
            <span>一区二区三区 · 完整导航指南</span>
          </div>
        </div>
      </div>
    </footer>
  );
}